/**
 * checks that the string contains json
 * @param str String
 * @returns json - value is json or null
 */
export var jsonParse = function (str) {
    try {
        return JSON.parse(str);
    }
    catch (e) {
        return null;
    }
};
